import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getRequiredRolesByOrgLevelTypeId from './GetRequiredRolesByOrgLevelTypeIdData';
import getRequiredRolesByOrgLevelTypeIdAndOrgUnitId from './GetRequiredRolesByOrgLevelTypeIdAndOrgUnitIdData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const RequiredRolesData = {
  INITIAL_STATE,
  getRequiredRolesByOrgLevelTypeId,
  getRequiredRolesByOrgLevelTypeIdAndOrgUnitId
};

export default RequiredRolesData;